export default __webpack_public_path__ + "static/media/Idea_1A.ea2c4ae9.png";